import { render } from "./payrecent.vue?vue&type=template&id=22a1a22b"
import script from "./payrecent.vue?vue&type=script&lang=js"
export * from "./payrecent.vue?vue&type=script&lang=js"

import "./payrecent.vue?vue&type=style&index=0&id=22a1a22b&lang=less"
script.render = render

export default script